import React from 'react';

const AuthLoading = () => {
  return <h3>Authentication is in progress...</h3>;
};

export default AuthLoading;
